export const OPPORTUNITY_STAGE = {
  closedLost: 'Closed Lost',
  confirmingNeeds: 'Confirming Needs',
  developingProposal: 'Developing Proposal',
  negotiating: 'Negotiating',
  open: 'Open',
  closedWon: 'Closed Won',
  sold: 'Sold',
  future: 'Future',
  closed: 'Closed',
  sentToIpForPricing: 'Sent to IP for Pricing',
  pricingInProgress: 'Pricing in Progress',
  sentForPricing: 'Sent for Pricing',
  pricingComplete: 'Pricing Complete'
};

export class OpportunityStage {
  public static getOpportunityStageColor(opportunityStage: string): string {
    let opportunityStageColor;
    switch (opportunityStage) {
      case OPPORTUNITY_STAGE.confirmingNeeds:
      case OPPORTUNITY_STAGE.developingProposal:
      case OPPORTUNITY_STAGE.negotiating:
      case OPPORTUNITY_STAGE.open:
        opportunityStageColor = 'text-orange';
        break;
      case OPPORTUNITY_STAGE.closedWon:
      case OPPORTUNITY_STAGE.sold:
        opportunityStageColor = 'text-green';
        break;
      case OPPORTUNITY_STAGE.closedLost:
        opportunityStageColor = 'text-red';
        break;
      case OPPORTUNITY_STAGE.future:
      case OPPORTUNITY_STAGE.closed:
        opportunityStageColor = 'text-grey';
        break;
      case OPPORTUNITY_STAGE.sentToIpForPricing:
      case OPPORTUNITY_STAGE.pricingInProgress:
      case OPPORTUNITY_STAGE.sentForPricing:
        opportunityStageColor = 'text-darkBlue';
        break;
      case OPPORTUNITY_STAGE.pricingComplete:
        opportunityStageColor = 'text-lightBlue';
        break;
      default:
        opportunityStageColor = 'text-grey';
    }
    return opportunityStageColor;
  }
}
